import React from "react";
import PropTypes from "prop-types";

const GlobalUploadStatus = ({ uploadStatus }) => {
  const { count, status } = uploadStatus;

  const totalUploads = status && Object.keys(status).length;

  const uploadProgressTotal =
    status &&
    Object.values(status).reduce((total, { progress }) => total + progress, 0);
  const currentProgress =
    status && (uploadProgressTotal * 100) / (totalUploads * 100);

  return (
    <>
      {count > 0 && (
        <div id="global-upload-status" className="mx-4 global-upload-status">
          <div className="global-upload-status__progress-bar">
            <div className="global-upload-status__text">
              <span>Uploading:</span>
              <span className="ml-1">{count}</span>
            </div>
            <div
              className="global-upload-status__progress-bar-value"
              style={{ width: `${currentProgress}%` }}
            ></div>
          </div>
        </div>
      )}
    </>
  );
};

GlobalUploadStatus.propTypes = {
  uploadStatus: PropTypes.shape()
};

export default GlobalUploadStatus;
